import React, { useEffect, useState } from 'react';
import Wrapper from '../Wrapper';
import moment from 'moment';
import { withRouter } from 'react-router-dom';
import { logout } from 'redux/modules/auth/action';
import { connect } from 'react-redux';

const PreviewModal = ({ getPreview, logout, history }) => {
    const [previewData, handleData] = useState(null);
    const [loading, handleLoad] = useState(false);
    const [error, handleError] = useState(null);
    useEffect(() => {

        const getData = async () => {
            try {
                handleLoad(true);
                handleError(null);
                const preview = await getPreview();
                handleData(preview);
                handleLoad(false);
            } catch (e) {
                handleLoad(false);
                if (e.errors.hasOwnProperty('title_path')) {
                    handleError('The Title must be selected');
                }
            }
        };
        getData();
    }, [getPreview, history, logout]);
    const convertDateString = (date) => {
        /*const timezone = (new Date(date).getTimezoneOffset() / 60) * -1;
        const hours = new Date(date).getHours() + timezone;
        const newDate = new Date(date).setHours(hours);*/
        //const newDate = new Date(date.replace(' ', 'T'));
        return moment(date).format(`MMMM DD, YYYY ${!date.includes('00:00:00.000000') ? 'hh:mm A' : ''}`);
    };
    return (
        <Wrapper>
            <h3>Newsfeed Preview:</h3>
            <div
                style={{
                    marginTop: 10,
                    height: '80vh',
                    overflowX: 'hidden',
                    overflowY: 'auto',
                }}
            >
                <div>
                    <div className="preview-box">
                        {loading || (!previewData && !error) ? (
                            <i className="fa fa-spinner fa-spin" />
                        ) : !error ? (
                            previewData.map((item, index) => {
                                return (
                                    <div key={index} className="preview-feed_item">
                                        <a style={{ color: '#20a8d8' }} className="d-block" href={item.link} target="noopener noreferrer_blank">
                                            {item.title}
                                        </a>
                                        {item.abstract ? <span>{item.abstract}</span> : ''}
                                        <br />
                                        {item.published_at ? <em style={{ color: 'rgb(134, 159, 172)' }}>{convertDateString(item.published_at.date)}</em> : ''}
                                    </div>
                                );
                            })
                        ) : (
                            <div className="error-container">
                                <i className="fas not-found-icon fa-exclamation-triangle" />
                                <div className="not-found-link">The Title must be selected</div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </Wrapper>
    );
};
export default connect(null, { logout })(withRouter(PreviewModal));
